import styled from 'styled-components'

export const BodyBlock = styled.div`
  min-height: calc(100vh - 20px);

  font-size: 18px;
  line-height: 26px;
  overflow-y: auto;

  h1 {
    font-weight: bold;
    font-size: 80px;
    line-height: 85px;
  }

  h2 {
    font-weight: bold;
    font-size: 50px;
    line-height: 60px;
  }

  h3 {
    font-weight: bold;
    font-size: 37px;
    line-height: 48px;
  }

  h4 {
    font-weight: bold;
    font-size: 27px;
    line-height: 38px;
  }

  h5 {
    font-weight: bold;
    font-size: 24px;
    line-height: 40px;
  }

  h6 {
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 40px;
      line-height: 42px;
    }

    h2 {
      font-size: 32px;
      line-height: 36px;
    }

    h3 {
      font-size: 28px;
      line-height: 34px;
    }

    h4 {
      font-size: 24px;
      line-height: 30px;
    }

    h5 {
      font-size: 22px;
      line-height: 28px;
    }

    h6 {
      font-size: 20px;
      line-height: 26px;
    }
  }
  @media (max-width: 360px) {
    > h1 {
      font-size: 27px;
    }
  }
`
